import { Link, Stack, Typography } from '@mui/material';
import LaunchAppButton from 'components/LaunchAppButton';
import { ConfigContext } from 'context';
import InstavisionButton from 'coreComponents/Button/Button';
import PopUp from 'coreComponents/PopUp/PopUp';
import { AppBridge } from 'infrastructure/appBridge/appBridge';
import { APP_BRIDGE_CALLBACKS } from 'infrastructure/appBridge/appCallBacks';
import { partnerAssets } from 'partners/partnersAssets';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PopupTypes } from 'typings/popUpTypes';
import { isRunningInWebView } from 'utils/webviewHelpers';
import { PopupIllustrationImage } from '../popupIllustrationStyle';

function PaymentFailedPopup() {
  const [isPopUpOpen, setIsPopUpOpen] = useState(true);
  const config = useContext(ConfigContext);
  // const PaymentFailedIcon = config.paymentFailed;
  const PaymentFailedIcon = partnerAssets.paymentFailedIcon;

  const { t } = useTranslation('translation', {
    keyPrefix: 'components.paymentFailedPopup'
  });

  const isWebViewPresent = isRunningInWebView();

  const { supportEmail } = config;

  const handlePopUpBackButtonClick = () => {
    setIsPopUpOpen(false);
    AppBridge.sendMessageToApp(APP_BRIDGE_CALLBACKS.CLOSE_IN_APP_WEBVIEW);
  };

  return (
    <PopUp isOpen={isPopUpOpen} type={PopupTypes.TYPE2}>
      <>
        <Stack direction="column" alignItems="center" justifyContent="center">
          <PopupIllustrationImage
            src={PaymentFailedIcon}
            alt="payment-failed"
          />
          <Typography variant="title1" paddingBottom="12px">
            {t('paymentFailedTitle')}
          </Typography>
        </Stack>
        <Stack marginBottom="12px" justifyContent="center" alignItems="center">
          <Typography
            variant="body2"
            sx={{ marginBottom: '2px', textAlign: 'center' }}
          >
            {t('contactSupportText')}
          </Typography>
          <Typography variant="body2" sx={{ marginBottom: '2px' }}>
            {t('email')} <Link href={supportEmail}>{supportEmail}</Link>
          </Typography>
          <Typography variant="body2" sx={{ marginBottom: '2px' }}>
            {t('phoneNumber')} {config.phoneNumber}{' '}
          </Typography>
        </Stack>
        <Stack direction="column" alignItems="Stretch" marginBottom="6px">
          {isWebViewPresent ? (
            <InstavisionButton
              sx={{
                marginBottom: '16px'
              }}
              onClick={() => handlePopUpBackButtonClick()}
            >
              {t('okay')}
            </InstavisionButton>
          ) : (
            <LaunchAppButton />
          )}
        </Stack>
      </>
    </PopUp>
  );
}
export default PaymentFailedPopup;
